<h2 class="lg:text-center pt-28 w-10/12 sm:w-9/12 mx-auto">
  {{ "main_page.industries_section.title" | translate }}
</h2>
<p class="w-10/12 sm:w-9/12 lg:text-center mx-auto pt-2.5 pb-11 lg:pb-9">
  {{ "main_page.industries_section.subtitle" | translate }}
</p>
<section
  class="w-10/12 sm:w-9/12 mx-auto grid sm:grid-cols-2 xl:grid-cols-4 gap-6"
>
  @for (industry of industries; track industry.id) {
    <div class="lg:mb-0 industry relative" [class.anchored]="!!industry.url">
      <div class="p-8 w-full">
        <img
          src="assets/img/MainPage/Industries/{{ industry.industryImage }}"
          alt="{{ industry.industryName | translate }}"
          class="lg:h-44 2xl:h-52 lg:mx-auto w-100 object-contain"
        />
        <h4 class="pt-10 pb-4">{{ industry.industryName | translate }}</h4>
        <p>{{ industry.industryDetail | translate }}</p>
      </div>
      @if (industry.url) {
        <a
          [langRouterLink]="industry.url"
          class="absolute top-0 right-0 bottom-0 left-0"
        ></a>
      }
    </div>
  }
</section>
